import React from 'react';
import { useNavigate } from "react-router-dom";
import {
    useTheme,
    MenuItem,
    Menu,
    Box,
} from '@mui/material';
import {
    LoginRounded,
    DashboardRounded,
    SettingsRounded,
    AddLinkRounded,
    AdminPanelSettingsRounded,
    CallMissedOutgoingRounded,
    TagRounded,
} from '@mui/icons-material';
import { withPather } from 'react-pather';
import { getTabSlug } from '../account/settings';
import { isAdmin } from '../../utils';

const HeaderMenu = ({ pather, anchorEl, handleClose, logout }) => {

    const navigate = useNavigate();
    const theme = useTheme();

    const click = func => {
        func();
        handleClose();
    }

    return (
        <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            MenuListProps={{
                onMouseLeave: handleClose,
                sx: { p: .5 },
            }}
            sx={{
                '.MuiMenu-paper': {
                    border: `1px solid ${theme.palette.mode === 'dark' ? '#1e2229' : '#AAB4BE'}`,
                    background: theme.palette.mode === 'dark' && '#222831',
                    borderRadius: '16px',
                }
            }}
            slotProps={{
                paper: {
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        '&::after': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 23,
                            width: 13,
                            height: 13,
                            bgcolor: `${theme.palette.mode === 'dark' ? '#1e2229' : '#AAB4BE'}`,
                            transform: 'translateY(-50%)',
                            clipPath: 'polygon(50% 0%, 100% 50%, 50% 50%, 0% 50%)',
                        },
                    },
                },
            }}
        >
            <HeaderMenuItem 
                onClick={() => click(() => navigate(pather.front.dashboard))}
                text='Dashboard'
                icon={<DashboardRounded />}
            />
            <HeaderMenuItem 
                onClick={() => click(() => navigate(pather.front.shorten))}
                text='Shorten'
                icon={<AddLinkRounded />}
            />
            <HeaderMenuItem 
                onClick={() => click(() => navigate(pather.front.redirects))}
                text='Redirects'
                icon={<CallMissedOutgoingRounded />}
            />
            <HeaderMenuItem 
                onClick={() => click(() => navigate(pather.front.tags))}
                text='Tags'
                icon={<TagRounded />}
            />
            {/* <HeaderMenuItem 
                onClick={handleClose}
                text='Plan'
                icon={<PaidRounded />}
            /> */}
            <HeaderMenuItem 
                onClick={() => click(() => navigate(pather.reverse(pather.front.settings, { slug: getTabSlug(0) })))}
                text='Settings'
                icon={<SettingsRounded />}
            />
            {
                isAdmin() &&
                <HeaderMenuItem 
                    onClick={() => click(() => window.open(pather.back.admin, '_blank'))}
                    text='Admin'
                    icon={<AdminPanelSettingsRounded/>}
                />
            }
            <HeaderMenuItem 
                onClick={logout}
                text='Log out'
                icon={<LoginRounded/>}
            />
        </Menu>
    );
} 

const HeaderMenuItem = ({ onClick, text, icon }) => {
    const theme = useTheme();
    return (
        <MenuItem 
            onClick={onClick} 
            sx={{                
                borderRadius: '12px',
                '&:hover': {
                    border: theme.palette.tinyBorder,
                },
                display: 'flex',
                gap: 2,
                px: 1.5,
                py: 1,
                alignItems: 'center',
            }}
        >
            <Box sx={{display: 'flex', alignItems: 'center'}}>
                {text}
            </Box> 
            <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
                {
                    React.cloneElement(
                        icon,
                        { 
                            fontSize: 'large',
                        }
                    )
                }
            </Box>
        </MenuItem>
    );
}

export default withPather()(HeaderMenu);